import { del, get, post, put } from '../client';

export const vendorsApi = {
  list: (params) => get('/vendors', { params }),
  getById: (id) => get(`/vendors/${id}`),
  create: (body) => post('/vendors', body),
  update: (id, body) => put(`/vendors/${id}`, body),
  assignBu: (id, body) => post(`/vendors/${id}/business-units`, body),
  revokeBu: (id, buId) => del(`/vendors/${id}/business-units/${buId}`),
  verify: (id, body) => post(`/vendors/${id}/verify`, body),
  regeneratePortalToken: (id) => post(`/vendors/${id}/portal-token`),
  block: (id, body) => post(`/vendors/${id}/block`, body),
  remove: (id) => del(`/vendors/${id}`),
};
